import React, { useEffect, useState } from "react";
import FltLicenseForm from "../components/Element/SideBarForms/FltLicenseForm";
import Profilesidebar from "../components/Element/Profilesidebar";
import FltLicenseContainer from "../containers/FltLicenseContainer";
import { isMobileOrLaptop } from "../services/CheckDevice";
import ProfileSideBarMobile from "../components/Element/ProfileSideBarMobile";
const FltLicense = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End
  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice && checkDevice == "Mobile" ? (
                  <ProfileSideBarMobile page="flt-license" />
                ) : (
                  <Profilesidebar page="flt-license" />
                )}
                <div className="col-xl-9 col-lg-8 m-b30">
                  <FltLicenseForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FltLicenseContainer(FltLicense);
